export const presetAxisColors = ['#D32F2F', '#7B1FA2', '#303F9F', '#0288D1','#00796B', '#689F38', '#FBC02D', '#F57C00']